import { ADD_DOCUMENT, ADD_DOCUMENT_ATTACHMENT, GET_DOCUMENTS, GET_DETAIL_DOCUMENT, DELETE_DOCUMENT_ATTACHMENT, ADD_COMMENT, GET_DOC_SHARED_WITH_ME, GET_FOLDER_PAGE, EDIT_DOCUMENT, DELETE_ALL_DOCUMENT_ATTACHMENT, DELETE_DOCUMENT, GET_FILTER_SEARCH, GET_FILTER_LIST, RATE_DOCUMENT, UPDATE_DOCUMENT_ATTACHMNET, SET_LASTPATH, GET_UNKER_PREPARING, GET_SATKER_PREPARING, ADD_ATTACHMENT_COMMENT, DELETE_ATTACHMENT_COMMENT, DELETE_ALL_ATTACHMENT_COMMENT, GET_DOCUMENT_COUNTER } from "shared/constants/ActionTypes";

const initialState = {
    documents: {},
    detailDoc: null,
    refresh: false,
    filter: 'draft',
    documentAttachment: [],
    commentAttachment: [],
    currentFolder: '',
    lastPath: localStorage.getItem('lastPathPreShare') ? localStorage.getItem('lastPathPreShare') : '',
    unker: [],
    satker: [],
    documentCounter: null
}

const repositoryReducer = (state = initialState, action) => {
    switch (action.type) {
        case GET_DOCUMENTS:
            return {
                ...state,
                documents: action.payload
            }
        case GET_DOC_SHARED_WITH_ME:
            return {
                ...state,
                documents: action.payload
            }
        case GET_FILTER_SEARCH:
            return {
                ...state,
                documents: action.payload
            }
        case ADD_DOCUMENT_ATTACHMENT:
            return {
                ...state,
                documentAttachment: [...state.documentAttachment, action.payload]
            }
        case ADD_ATTACHMENT_COMMENT:
            return {
                ...state,
                commentAttachment: [...state.commentAttachment, action.payload]
            }
        case ADD_DOCUMENT:
            return {
                ...state
            }
        case EDIT_DOCUMENT:
            return {
                ...state,
            }
        case GET_DETAIL_DOCUMENT:
            return {
                ...state,
                detailDoc: action.payload
            }
        case DELETE_DOCUMENT_ATTACHMENT:
            return {
                ...state,
                documentAttachment: action.payload
            }
        case DELETE_ATTACHMENT_COMMENT:
            return {
                ...state,
                commentAttachment: action.payload
            }
        case ADD_COMMENT:
            return {
                ...state,
                detailDoc: action.payload
            }
        case GET_FOLDER_PAGE:
            return {
                ...state,
                currentFolder: action.payload
            }
        case DELETE_ALL_DOCUMENT_ATTACHMENT:
            return {
                ...state,
                documentAttachment: []
            }
        case DELETE_ALL_ATTACHMENT_COMMENT:
            return {
                ...state,
                commentAttachment: []
            }
        case DELETE_DOCUMENT:
            return {
                ...state
            }
        case GET_FILTER_LIST:
            return {
                ...state,
                filter: action.payload
            }
        case RATE_DOCUMENT:
            return {
                ...state,
            }
        case UPDATE_DOCUMENT_ATTACHMNET:
            return {
                ...state,
            }
        case SET_LASTPATH:
            return {
                ...state,
                lastPath: action.payload
            }
        case GET_UNKER_PREPARING:
            return {
                ...state,
                unker: action.payload
            }
        case GET_SATKER_PREPARING:
            return {
                ...state,
                satker: action.payload
            }
        case GET_DOCUMENT_COUNTER:
            return {
                ...state,
                documentCounter: action.payload
            }
        default:
            return {
                ...state
            }
    }
};

export default repositoryReducer;